/**
 * FlowAI Audit-Trail — Cross-Workspace.
 *
 * @page /flowai/audit
 * @since v2.484.0
 */
import { useEffect, useState } from 'react';
import { PageHeader, Card, Badge } from '../../components/ui';
import { IconCases } from '../../components/Icons';
import FlowAIBreadcrumb from '../../components/flowai/FlowAIBreadcrumb';

const API = import.meta.env.VITE_API_URL || '';

export default function FlowAIAudit() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    fetch(`${API}/api/flowai/audit?limit=200`, { credentials: 'include' })
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : (d?.entries ?? [])))
      .catch(() => setRows([]));
  }, []);
  return (
    <div className="p-6">
      <FlowAIBreadcrumb trail={[{ label: 'Audit-Trail' }]} />
      <PageHeader title="Audit-Trail" subtitle="Letzte 200 FlowAI-Aktionen" />
      <Card padding="sm">
        <div className="divide-y divide-[var(--border-subtle,#E5E7EB)] max-h-[80vh] overflow-y-auto">
          {rows.map((a) => (
            <div key={a.id} className="p-3 text-[12px]">
              <div className="flex items-center gap-2">
                <span className="font-mono text-[var(--text-tertiary,#6B7280)]">#{a.id}</span>
                <span className="font-medium">{a.action_type}</span>
                <Badge>{a.approval_status || a.status}</Badge>
                {a.related_case_id && <Badge variant="default">Case #{a.related_case_id}</Badge>}
                {a.workspace_name && <span className="text-[var(--text-tertiary,#6B7280)]">{a.workspace_name}</span>}
                <span className="ml-auto text-[var(--text-tertiary,#6B7280)]">{new Date(a.created_at).toLocaleString()}</span>
              </div>
              {a.action_payload?.subject && <div className="mt-1 text-[var(--text-secondary,#4B5563)]">{a.action_payload.subject}</div>}
            </div>
          ))}
          {rows.length === 0 && (
            <div className="p-12 text-center">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[var(--bg-inset,#F8F9FC)] mb-3">
                <IconCases className="w-6 h-6 text-[var(--text-tertiary,#6B7280)]" />
              </div>
              <div className="text-sm font-medium mb-1">Noch keine Audit-Einträge</div>
              <div className="text-[12px] text-[var(--text-tertiary,#6B7280)]">Jede genehmigte/abgelehnte AI-Aktion wird hier protokolliert.</div>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
